import "./common.css";

export default function Header() {
	return (
		<div className="header">
			<h1><a className="header-home" href="/">Onthego</a></h1>
			<a className="header-signup" href="https://forms.gle/FimVyZUjJJPDCMBs7" target="_blank">Sign Up</a>
		</div>
	);
}